var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkipass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 340,
    viewBox: "0 0 383 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_457_376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.005 98.6919C296.666 104.771 304.722 108.461 313.757 108.461C330.956 108.461 345 94.567 345 77.3082C345 60.157 331.065 46.1543 313.757 46.1543C304.83 46.1543 296.775 49.9534 291.005 55.9239",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 97.2788C296.661 103.328 304.718 107 313.754 107C330.955 107 345 93.1742 345 76.0004C345 58.9337 331.064 45 313.754 45C304.826 45 296.77 48.7803 291 54.7215",
    stroke: "#5388C9",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.039 314.093H132.47C121.29 314.093 112.303 305.13 112.303 293.983V44.1382V22.7168C112.303 11.5688 121.29 2.60681 132.47 2.60681H269.259C280.438 2.60681 289.426 11.5688 289.426 22.7168V293.983C289.207 305.13 280.219 314.093 269.039 314.093Z",
    fill: "white",
    stroke: "#5388C9",
    strokeWidth: 5.52895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.468 301.632C128.302 301.632 124.795 298.134 124.795 293.981V22.7154C124.795 18.5623 128.302 15.0649 132.468 15.0649H269.256C273.42 15.0649 276.928 18.5623 276.928 22.7154V293.981C276.928 298.134 273.42 301.632 269.256 301.632H132.468Z",
    stroke: "#5388C9",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.465 295.515C131.589 295.515 130.931 294.858 130.931 293.985V22.7183C130.931 21.844 131.589 21.1882 132.465 21.1882H269.254C270.13 21.1882 270.789 21.844 270.789 22.7183V293.985C270.789 294.858 270.13 295.515 269.254 295.515H132.465Z",
    stroke: "#5388C9",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.3 44.1416H289.203",
    stroke: "#5388C9",
    strokeWidth: 5.52895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.3 270.816H289.203",
    stroke: "#5388C9",
    strokeWidth: 5.52895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.542 286.988H217.958",
    stroke: "#5388C9",
    strokeWidth: 5.52895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.931 104.255C147.372 83.9262 172.581 71.0299 200.86 71.0299C229.138 71.0299 254.128 83.9262 270.789 104.255",
    stroke: "#5388C9",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.204 144.691C289.423 145.348 289.423 146.221 289.643 146.878C290.3 151.468 290.738 156.058 290.738 160.648C290.738 163.49 290.52 166.55 290.3 169.392C290.081 171.796 289.643 174.419 289.204 176.824",
    stroke: "#5388C9",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.931 217.266C147.372 237.594 172.581 250.491 200.86 250.491C229.138 250.491 254.128 237.594 270.789 217.266",
    stroke: "#5388C9",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.302 144.914C112.302 145.351 112.082 146.007 112.082 146.444C111.863 147.1 111.863 147.755 111.863 148.412C111.644 150.16 111.425 152.127 111.205 153.876C110.986 156.062 110.986 158.466 110.986 160.652C110.986 166.117 111.425 171.363 112.302 176.609",
    stroke: "#5388C9",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.931 114.749C145.838 92.2349 171.704 77.371 200.86 77.371C230.015 77.371 255.663 92.2349 270.789 114.968",
    stroke: "#5388C9",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.931 206.772C145.838 229.287 171.704 244.369 200.86 244.369C230.015 244.369 255.663 229.505 270.789 206.772",
    stroke: "#5388C9",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.7,
    y: 63.7,
    width: 32.6,
    height: 24.6,
    rx: 1.3,
    fill: "white",
    stroke: "#5388C9",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 72H326C325.448 72 325 72.4477 325 73V79C325 79.5523 325.448 80 326 80H335C335.552 80 336 79.5523 336 79V73C336 72.4477 335.552 72 335 72Z",
    fill: "white",
    stroke: "#5388C9",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 76,
    r: 1.5,
    stroke: "#5388C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 152.587L164.593 118.95L176.506 135.535M159.454 130.629L164.593 132.498L169.965 130.629M156.183 171.041L201.5 104L247.05 171.274M194.5 120.585L201.5 124L208.508 120.585",
    stroke: "#5388C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 152.587L238.407 118.95L226.494 135.535M243.546 130.629L238.407 132.498L233.035 130.629",
    stroke: "#5388C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5 145.656L153.5 150.156M244.5 143.156L250 150.156",
    stroke: "#5388C9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 197C175 197 177.578 179.209 209.235 171.5C217.454 169.498 217.727 163.78 201.593 156.873C200.322 156.329 200.669 156.022 201.493 156C202.55 155.972 209.182 158.457 211 159.5C222 164 223.72 167.501 219.654 171.5C215.588 175.499 200.304 178.139 203.731 197",
    stroke: "#5388C9",
    strokeWidth: 1.37
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-1_457_376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.619 158C177.277 158 177 158.265 177 158.591V170.409C177 170.735 177.277 171 177.619 171C177.961 171 178.238 170.735 178.238 170.409V166.682L186.197 163.834C187.268 163.45 187.268 162.004 186.197 161.621L178.238 158.772V158.591C178.238 158.265 177.961 158 177.619 158ZM178.238 160.035V165.42L185.453 162.838C185.56 162.8 185.56 162.655 185.453 162.617L178.238 160.035Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.238 166.682L177.564 164.799L176.238 165.274V166.682H178.238ZM186.197 163.834L186.87 165.717L186.87 165.717L186.197 163.834ZM186.197 161.621L185.523 163.504L185.523 163.504L186.197 161.621ZM178.238 158.772H176.238V160.181L177.564 160.655L178.238 158.772ZM178.238 160.035L178.912 158.152L176.238 157.194V160.035H178.238ZM178.238 165.42H176.238V168.26L178.912 167.303L178.238 165.42ZM185.453 162.838L186.127 164.721L186.127 164.721L185.453 162.838ZM185.453 162.617L186.127 160.734L186.127 160.734L185.453 162.617ZM177.619 158V156C176.262 156 175 157.073 175 158.591H177H179C179 159.456 178.293 160 177.619 160V158ZM177 158.591H175V170.409H177H179V158.591H177ZM177 170.409H175C175 171.927 176.262 173 177.619 173V171V169C178.293 169 179 169.544 179 170.409H177ZM177.619 171V173C178.977 173 180.238 171.927 180.238 170.409H178.238H176.238C176.238 169.544 176.945 169 177.619 169V171ZM178.238 170.409H180.238V166.682H178.238H176.238V170.409H178.238ZM178.238 166.682L178.912 168.565L186.87 165.717L186.197 163.834L185.523 161.951L177.564 164.799L178.238 166.682ZM186.197 163.834L186.87 165.717C189.71 164.701 189.71 160.754 186.87 159.738L186.197 161.621L185.523 163.504C185.223 163.397 185 163.072 185 162.727C185 162.383 185.223 162.058 185.523 161.951L186.197 163.834ZM186.197 161.621L186.87 159.738L178.912 156.889L178.238 158.772L177.564 160.655L185.523 163.504L186.197 161.621ZM178.238 158.772H180.238V158.591H178.238H176.238V158.772H178.238ZM178.238 158.591H180.238C180.238 157.073 178.977 156 177.619 156V158V160C176.945 160 176.238 159.456 176.238 158.591H178.238ZM178.238 160.035H176.238V165.42H178.238H180.238V160.035H178.238ZM178.238 165.42L178.912 167.303L186.127 164.721L185.453 162.838L184.779 160.955L177.564 163.537L178.238 165.42ZM185.453 162.838L186.127 164.721C188.002 164.05 188.002 161.405 186.127 160.734L185.453 162.617L184.778 164.5C183.118 163.905 183.118 161.55 184.778 160.955L185.453 162.838ZM185.453 162.617L186.127 160.734L178.912 158.152L178.238 160.035L177.564 161.918L184.779 164.5L185.453 162.617Z",
    fill: "#5388C9",
    mask: "url(#path-22-inside-1_457_376)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-2_457_376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.619 191C242.277 191 242 191.265 242 191.591V203.409C242 203.735 242.277 204 242.619 204C242.961 204 243.238 203.735 243.238 203.409V199.682L251.197 196.834C252.268 196.45 252.268 195.004 251.197 194.621L243.238 191.772V191.591C243.238 191.265 242.961 191 242.619 191ZM243.238 193.035V198.42L250.453 195.838C250.56 195.8 250.56 195.655 250.453 195.617L243.238 193.035Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243.238 199.682L242.564 197.799L241.238 198.274V199.682H243.238ZM251.197 196.834L251.87 198.717L251.87 198.717L251.197 196.834ZM251.197 194.621L250.523 196.504L250.523 196.504L251.197 194.621ZM243.238 191.772H241.238V193.181L242.564 193.655L243.238 191.772ZM243.238 193.035L243.912 191.152L241.238 190.194V193.035H243.238ZM243.238 198.42H241.238V201.26L243.912 200.303L243.238 198.42ZM250.453 195.838L251.127 197.721L251.127 197.721L250.453 195.838ZM250.453 195.617L251.127 193.734L251.127 193.734L250.453 195.617ZM242.619 191V189C241.262 189 240 190.073 240 191.591H242H244C244 192.456 243.293 193 242.619 193V191ZM242 191.591H240V203.409H242H244V191.591H242ZM242 203.409H240C240 204.927 241.262 206 242.619 206V204V202C243.293 202 244 202.544 244 203.409H242ZM242.619 204V206C243.977 206 245.238 204.927 245.238 203.409H243.238H241.238C241.238 202.544 241.945 202 242.619 202V204ZM243.238 203.409H245.238V199.682H243.238H241.238V203.409H243.238ZM243.238 199.682L243.912 201.565L251.87 198.717L251.197 196.834L250.523 194.951L242.564 197.799L243.238 199.682ZM251.197 196.834L251.87 198.717C254.71 197.701 254.71 193.754 251.87 192.738L251.197 194.621L250.523 196.504C250.223 196.397 250 196.072 250 195.727C250 195.383 250.223 195.058 250.523 194.951L251.197 196.834ZM251.197 194.621L251.87 192.738L243.912 189.889L243.238 191.772L242.564 193.655L250.523 196.504L251.197 194.621ZM243.238 191.772H245.238V191.591H243.238H241.238V191.772H243.238ZM243.238 191.591H245.238C245.238 190.073 243.977 189 242.619 189V191V193C241.945 193 241.238 192.456 241.238 191.591H243.238ZM243.238 193.035H241.238V198.42H243.238H245.238V193.035H243.238ZM243.238 198.42L243.912 200.303L251.127 197.721L250.453 195.838L249.779 193.955L242.564 196.537L243.238 198.42ZM250.453 195.838L251.127 197.721C253.002 197.05 253.002 194.405 251.127 193.734L250.453 195.617L249.778 197.5C248.118 196.905 248.118 194.55 249.778 193.955L250.453 195.838ZM250.453 195.617L251.127 193.734L243.912 191.152L243.238 193.035L242.564 194.918L249.779 197.5L250.453 195.617Z",
    fill: "#5388C9",
    mask: "url(#path-24-inside-2_457_376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.765 186.727H159.768L161.254 188.393L165.768 193.45H159.5V199.656H158.5V193.45H152.232L156.746 188.393L158.232 186.727H152.235L158.999 179.156L165.765 186.727Z",
    stroke: "#5388C9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.765 173.727H235.768L237.254 175.393L241.768 180.45H235.5V186.656H234.5V180.45H228.232L232.746 175.393L234.232 173.727H228.235L234.999 166.156L241.765 173.727Z",
    stroke: "#5388C9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9351 180.358L39.1789 185.769C38.565 185.88 38 185.409 38 184.785V181.205C38 180.717 38.3534 180.299 38.8356 180.219L67.529 175.437V176.735C67.529 177.722 67.8212 178.687 68.3687 179.509L68.9351 180.358Z",
    fill: "white",
    stroke: "#5388C9",
    strokeWidth: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.682 235.901H45.0305V232.573C45.0305 230.916 46.3737 229.573 48.0305 229.573H99.6823C101.339 229.573 102.682 230.916 102.682 232.573V235.901Z",
    fill: "white",
    stroke: "#5388C9",
    strokeWidth: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7952 192.311H86.918C87.4703 192.311 87.918 192.758 87.918 193.311V194.42H105.713C107.922 194.42 109.713 196.211 109.713 198.42V221.355C109.713 223.564 107.922 225.355 105.713 225.355H99.8702V222.543V219.73H104.495C105.047 219.73 105.495 219.283 105.495 218.73V209.536V200.341C105.495 199.789 105.047 199.341 104.495 199.341H87.918V200.45C87.918 201.003 87.4703 201.45 86.918 201.45H60.7952C60.2429 201.45 59.7952 201.003 59.7952 200.45V193.311C59.7952 192.758 60.2429 192.311 60.7952 192.311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.918 194.42V193.311C87.918 192.758 87.4703 192.311 86.918 192.311H60.7952C60.2429 192.311 59.7952 192.758 59.7952 193.311V200.45C59.7952 201.003 60.2429 201.45 60.7952 201.45H86.918C87.4703 201.45 87.918 201.003 87.918 200.45V199.341M87.918 194.42H105.713C107.922 194.42 109.713 196.211 109.713 198.42V221.355C109.713 223.564 107.922 225.355 105.713 225.355H99.8702V222.543V219.73H104.495C105.047 219.73 105.495 219.283 105.495 218.73V209.536V200.341C105.495 199.789 105.047 199.341 104.495 199.341H87.918M87.918 194.42V199.341",
    stroke: "#5388C9",
    strokeWidth: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 194.42H59.7952V199.341H43.2184C42.6661 199.341 42.2184 199.789 42.2184 200.341V209.536V218.73C42.2184 219.283 42.6661 219.73 43.2184 219.73H47.843V222.543V225.355H42C39.7908 225.355 38 223.564 38 221.355V198.42C38 196.211 39.7908 194.42 42 194.42Z",
    fill: "white",
    stroke: "#5388C9",
    strokeWidth: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.167 229.573H82.2933H65.4196H48.5459V211.606C48.5459 209.2 50.6546 207.339 53.042 207.637L65.4196 209.184H82.2933L94.6709 207.637C97.0583 207.339 99.167 209.2 99.167 211.606V229.573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2933 229.573H99.167V211.606C99.167 209.2 97.0583 207.339 94.6709 207.637L82.2933 209.184M82.2933 229.573V218.324V209.184M82.2933 229.573H65.4196M82.2933 209.184H65.4196M65.4196 229.573V209.184M65.4196 229.573H48.5459V211.606C48.5459 209.2 50.6546 207.339 53.042 207.637L65.4196 209.184",
    stroke: "#5388C9",
    strokeWidth: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0444 182.468V192.311H76.669V182.468H71.0444Z",
    fill: "white",
    stroke: "#5388C9",
    strokeWidth: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.792 235.901H44.9214C43.8168 235.901 42.9214 236.796 42.9214 237.901V238.119C42.9214 239.224 43.8168 240.119 44.9214 240.119H102.792C103.896 240.119 104.792 239.224 104.792 238.119V237.901C104.792 236.796 103.896 235.901 102.792 235.901Z",
    fill: "white",
    stroke: "#5388C9",
    strokeWidth: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.607 173.501L76.2288 179.13C74.6383 179.399 73.2004 178.144 73.2508 176.532C73.2888 175.316 74.1794 174.295 75.3792 174.093L109.373 168.36C109.996 168.255 110.559 168.746 110.539 169.377L110.44 172.547C110.425 173.023 110.076 173.422 109.607 173.501Z",
    fill: "white",
    stroke: "#5388C9",
    strokeWidth: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5291 175.515V177.468C67.5291 180.229 69.7676 182.468 72.5291 182.468H75.1843C77.9458 182.468 80.1843 180.229 80.1843 177.468V175.515C80.1843 172.754 77.9458 170.515 75.1843 170.515H72.5291C69.7676 170.515 67.5291 172.754 67.5291 175.515Z",
    fill: "white",
    stroke: "#5388C9",
    strokeWidth: 1.35
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_457_376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 383,
    height: 340,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipass);
export default __webpack_public_path__ + "static/media/skipass.14920e50dee4a1b0f63964b08582dacd21dcfe30fade20e0cc341f8627064802.svg";
export { ForwardRef as ReactComponent };